export default "__VITE_ASSET__bb4481f9__"